module.exports = __webpack_public_path__ + "static/media/logo-white.fa22ba93.png";


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/Topbar/atoms/Logo/logo-white.png
// module id = 205
// module chunks = 101